import React from 'react'
import ReactDOM from 'react-dom'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import './services/polyfills'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { GlobalProvider } from './contexts/global'
import { CoursesProvider } from './contexts/courses'
import './tailwind.css'
import './styles/templates/templates.css'
import './index.scss'

const root = document.getElementById('root')
/**
 * A prerendered page (`scripts/seo/`) arrives with markup in #root, and hydrate keeps it.
 * render would delete it and build the page again, so the photos and carousels blink.
 * The SPA shell and the prerender itself start from an empty #root and take render.
 */
const mount = root && root.hasChildNodes() ? ReactDOM.hydrate : ReactDOM.render

mount(
  <React.StrictMode>
    <BrowserRouter>
      <CoursesProvider>
        <GlobalProvider>
          <App />
        </GlobalProvider>
      </CoursesProvider>
    </BrowserRouter>
  </React.StrictMode>,
  root
)
